// /dashboard/:orgSlug/settings — Figma frame 18 settings (33:845).
// Owner: screens-ops, US-131.

import { createRoute } from "@tanstack/react-router";
import { shellRoute } from "./_shell";
import { SettingsScreen } from "../screens/ops/SettingsScreen";

export const settingsRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: "/dashboard/$orgSlug/settings",
  staticData: { title: "Settings" },
  component: SettingsRoute,
});

function SettingsRoute() {
  const { orgSlug } = settingsRoute.useParams();
  return (
    <SettingsScreen orgSlug={orgSlug} />
  );
}
